export const MOBILE = '@media (max-width: 425px), (max-height: 350px)';
